//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    width: 100%;
    max-height: ${({ maxHeight = "60vh"}) => maxHeight};
    margin-top: 15px;
    overflow-x: scroll;
    &::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        @media (min-width: 700px) {
            width: 8px;
            height: 8px;
        }
    }
    &::-webkit-scrollbar-corner {
        background-color: transparent;
    }
    &::-webkit-scrollbar-track {
        background-color: transparent;
    }
    &.primary::-webkit-scrollbar-thumb {
        background-color: var(--purple-2);
    }
    &.secondary::-webkit-scrollbar-thumb {
        background-color: var(--light-blue-3);
    }
`;
export const Table = styled.table`
    border-collapse: collapse;
    min-width: ${({ minWidth = "600px" }) => minWidth};
    width: 100%;
    overflow-x: hidden;
    & > thead {
        position: sticky;
        z-index: 20;
        top: 0;
        background-color: var(--light-blue-2);
        transition: 0.35s;
        box-shadow: ${({ boxShadow = "unset" }) => boxShadow};
    }
    &.secondary > thead {
        background-color: var(--light-1);
    }
    & > tbody tr:nth-child(odd) .pair-row {
        background-color: var(--light-blue-2);
    }
`;
export const TLBody = styled.tbody`
`;
export const TLCellHead = styled.th`
    & > div {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 20px;
        gap: 10px;
        & span {
            font-size: 12px;
            font-weight: bold;
        }
    }
`;